import React, { useMemo } from 'react';
import { Card, CardBody, Col, Row } from 'react-bootstrap';
import BreadCrumb from '../../../components/common/BreadCrumb';
import { TableResponsive } from '../../../components/common/TableResponsive';
import { useStatusEnquiry, StatusEnquiryHeader } from './StatusEnquiry/index';
import { getEnquiryColumns } from './EnquiryList/enquiryColumns';
import './EnquiryList/EnquiryList.css';

const CompletedEnquiry = () => {
    const {
        enquirys,
        totalCount,
        districtList,
        selectedDistrict,
        setSelectedDistrict,
        isLoading,
        authData,
        searchTerm,
        setSearchTerm,
        handleEnquiryDelete,
        handleReport
    } = useStatusEnquiry('completed');

    const columns = useMemo(
        () =>
            getEnquiryColumns({
                authData,
                enquirys,
                handleEnquiryDelete,
                handleReport
            }),
        [authData, enquirys, handleEnquiryDelete, handleReport]
    );

    return (
        <>
            <BreadCrumb title="Completed Leads" prevPage="Enquiry" prevPath="/enquiry" />
            <Row>
                <Col xs={12}>
                    <Card className="border-0 shadow-sm">
                        <StatusEnquiryHeader
                            title="Completed & Converted Leads"
                            subtitle="All candidate and school enquiries successfully converted or closed"
                            icon="ri-checkbox-circle-line"
                            badgeColor="success"
                            badgeLabel="Total Converted"
                            count={totalCount}
                            districtList={districtList}
                            selectedDistrict={selectedDistrict}
                            setSelectedDistrict={setSelectedDistrict}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                        />
                        <CardBody className="p-0 p-md-3">
                            <TableResponsive
                                isLoading={isLoading}
                                columns={columns}
                                data={enquirys}
                                noRecord="No Completed Enquiries Found"
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default CompletedEnquiry;
